import moment from 'moment';

angular
  .module('bb.appointments')
  .factory('AppointmentStatusService', AppointmentStatusService);

AppointmentStatusService.$inject = ['$resource'];

function getStatusName(statusName, appointmentDetails = {}) {
  if (
    appointmentDetails &&
    appointmentDetails.isPending &&
    appointmentDetails.lastAction?.actionTaken.includes('Auto Confirmed')
  ) {
    return 'pending';
  }
  if (statusName === 'confirm') return 'confirmed';
  if (statusName === 'deny') return 'denied';
  if (statusName === 'cancel') return 'cancelled';
  if (statusName === 'time_change') return 'time changed';
  if (statusName === 'time_passed') return 'time passed';
  return statusName;
}

function AppointmentStatusService($resource) {
  const AppointmentStatus = $resource(
    '/appointments/send/:appointmentId/:detailsType',
    { appointmentId: '@appointmentId', detailsType: '@detailsType' },
  );

  const SentriLock = $resource(
    '/listing/:listingId/appointments/sentrilock/:lbsn',
    {
      listingId: '@listingId',
      lbsn: '@lbsn',
    },
  );

  function saveAppointmentStatus(details) {
    return AppointmentStatus.save(details).$promise;
  }

  function validateSentrilock(details) {
    return SentriLock.get(details).$promise;
  }

  function initScope(ctrl) {
    ctrl.moment = moment;
    ctrl.getStatusName = getStatusName;
    ctrl.selectReason = reason => {
      if (reason === 'anotherTime') {
        ctrl.selectedTimeOption = 'after';
        ctrl.selectedTime = new Date(ctrl.data.appointment.time);
        ctrl.data.appointment.details = `Please book for ${
          ctrl.selectedTimeOption
        } ${moment(ctrl.selectedTime).format('h:mm a')}`;
      } else if (reason === 'anotherDay') {
        ctrl.data.appointment.details = 'Please book for another day';
      } else {
        ctrl.data.appointment.details = '';
      }
    };
  }
  return {
    initScope,
    getStatusName,
    saveAppointmentStatus,
    validateSentrilock,
  };
}
